import { isRoomJoined } from '../../room';
import { SET_DUAL_MONITOR } from '../../video-layout/actionTypes';
import { ROLE, getLocalMember } from '../members';
import { MEDIA_TYPE } from '../media';
import { MiddlewareRegistry } from '../redux';
import { toggleChat, toggleMember } from '../sidebar';
import { getTracksByTrackIdAndMediaType, isLocalTrackMutedByMediaType } from '../tracks';
import { SETTINGS_UPDATED } from './actionTypes';
import { updateSettings } from './actions';
import { getPropertyValue } from './functions';
import './middleware.any';
// 미변경 장치의 재획득을 생략해도 되는지 — 기존 트랙이 muted(비디오는 mute 시 스트림이 해제되어
// 정상적으로 track 이 없음)이거나 아직 live 면 사용 가능. 트랙이 죽어 있으면(장치 뽑힘/BT 재연결 등)
// 같은 deviceId 라도 재획득해 복구해야 하므로 false. 판정 불가 시 false(=재획득, 종전 동작)로 폴백.
const isTrackUsable = (localTrack) => Boolean(localTrack?.muted || localTrack?.track?.getTrack?.()?.readyState === 'live');
MiddlewareRegistry.register(store => next => async (action) => {
    switch (action.type) {
        case SET_DUAL_MONITOR:
            if (action.isDualMonitor) {
                store.dispatch(toggleChat(true));
                store.dispatch(toggleMember(true));
                store.dispatch(updateSettings({ dualSideOpen: true }));
            }
            else {
                store.dispatch(updateSettings({ dualSideOpen: false }));
            }
            break;
        case SETTINGS_UPDATED:
            if (action.settings.userSelectedAudioOutputDeviceId) {
                APP.management.setAudioOutputDevice(action.settings.userSelectedAudioOutputDeviceId).catch(err => { });
            }
            if (isRoomJoined(store.getState())) {
                // 미들웨어는 next(action) "전"에 실행되므로 여기서 읽는 settings 는 변경 전 값 —
                // 장치 미변경(다이얼로그 확인만 클릭) 판정의 비교 기준으로 사용한다.
                const prevSettings = store.getState()['features/base/settings'];
                if (action.settings.userSelectedMicDeviceId) {
                    const localAudio = getTracksByTrackIdAndMediaType(store.getState, 'local', MEDIA_TYPE.AUDIO);
                    // ★이 게이트 제거 금지(2026-07-20 "장치설정 저장만으로 마이크 켜짐" 실사고).
                    // 청취자(비HOST && !individualLive)는 마이크 트랙 미보유가 불변식이다(마이크 점유 시
                    // 모바일이 통화모드로 들어가 BT 미디어(A2DP) 라우팅이 SCO 통화음성으로 깨짐 — 332e81ec).
                    // muted 트랙이라도 만들면 불변식 위반이고, 과거엔 여기서 만든 트랙의 mute 미완료
                    // 상태(stale isMuted)가 SET_AUDIO_MUTED(false)로 역전파되어 즉석획득·unmuted 송출까지
                    // 이어졌다. 설정 자체는 reducer 에 그대로 저장되므로 발언 허가 시
                    // acquireAndPublishAudio 가 userSelectedMicDeviceId 로 새 장치를 획득한다(기능 손실 없음).
                    // 단 "트랙 없는 HOST/individualLive"는 스킵하면 안 된다 — 헤더 unmute 버튼이
                    // localTrack 부재 시 무반응(ToggleAudioButton)이라, 여기서 muted 트랙을 만들어 줘야
                    // 마이크 권한을 뒤늦게 허용한 진행자가 복구할 수 있다.
                    const isListener = !(getLocalMember(store.getState)?.role === ROLE.HOST ||
                        getPropertyValue(store.getState, 'individualLive'));
                    const sameMic = action.settings.userSelectedMicDeviceId === prevSettings.userSelectedMicDeviceId;
                    // 트랙 보유자: 장치가 실제로 바뀌었거나 기존 트랙이 죽었을 때만 교체(확인 버튼만
                    // 눌러도 매번 마이크를 갈아끼우던 재획득 churn 제거). 트랙 미보유자: 청취자는 스킵.
                    const shouldUpdateAudio = localAudio ? !(sameMic && isTrackUsable(localAudio)) : !isListener;
                    if (shouldUpdateAudio) {
                        console.log('settings.userSelectedMicDeviceId', action.settings.userSelectedMicDeviceId);
                        APP.management.updateTrack(action.settings.userSelectedMicDeviceId, MEDIA_TYPE.AUDIO, {
                            muted: action?.settings?.userSelectedAudioMuted ||
                                isLocalTrackMutedByMediaType(store.getState, MEDIA_TYPE.AUDIO),
                        });
                    }
                }
                if (action.settings.userSelectedCameraDeviceId) {
                    // 비디오는 청취자 개념이 없다(학생도 입장 시 비디오 트랙 보유) — 미변경+사용 가능이면
                    // 재획득만 생략하고, 트랙이 없으면(권한 거부 입장 등) 종전대로 생성해 준다.
                    const localVideo = getTracksByTrackIdAndMediaType(store.getState, 'local', MEDIA_TYPE.VIDEO);
                    const sameCamera = action.settings.userSelectedCameraDeviceId === prevSettings.userSelectedCameraDeviceId;
                    if (!localVideo || !(sameCamera && isTrackUsable(localVideo))) {
                        APP.management.updateTrack(action.settings.userSelectedCameraDeviceId, MEDIA_TYPE.VIDEO, {
                            muted: action?.settings?.userSelectedCameraMuted ||
                                isLocalTrackMutedByMediaType(store.getState, MEDIA_TYPE.VIDEO),
                        });
                    }
                }
            }
            break;
    }
    return next(action);
});
